(ns ui.editor2.extension-points
  "Extension points for the editor so that domain-specific aspects do not need
   to be part of the core editor logic.")

(defmulti composition-asset
  "How should the asset be rendered in the composition of the editor UI."
  (fn [params]
    (get-in params
            [:clip
             :clip/asset
             :asset/type])))

(defmethod composition-asset :default
  [params]
  ;; A clip whose asset type no code renders any more (e.g. a design
  ;; saved with a retired asset type) must not take the stage down:
  (js/console.warn "No composition for the asset type"
                   (str (get-in params [:clip :clip/asset :asset/type])))
  nil)

(defmulti composition-overlay
  "A layer above all clips of the composition, like the captions of the
   clips. Every method is rendered, the dispatch value names the layer."
  (fn [_params kind]
    kind))

(defmulti asset-thumbnail
  "Which thumbnail URL should be used to preview the asset in places like the
   media sidepanel."
  (fn [params]
    (get-in params
            [:asset
             :asset/type])))

(defmulti prepare-asset!
  "Prepare everything to show the asset in the editor."
  (fn [params]
    (get-in params
            [:asset
             :asset/type])))
